// extracted by mini-css-extract-plugin
export default {"box":"Dlo2BAxycEyGjT5bqMz2","description":"ZS63ECMu03aFVqO9xCEL"};